import { useEffect, useState } from 'react';
import isNil from 'lodash/isNil';

const useTimer = ({ expiry = 5000, onExpire, autoStart = true }) => {
  const [timerId, setTimerId] = useState();

  const setTimer = () => setTimerId(() => setTimeout(onExpire, expiry));

  const cleanUp = () => {
    clearTimeout(timerId);
    setTimerId(null);
  };

  useEffect(() => {
    if (!autoStart) {
      return;
    }
    setTimer();
    return cleanUp;
  }, [autoStart]);

  const reset = () => {
    if (!isNil(timerId)) {
      cleanUp();
    }
  };

  const start = () => {
    if (isNil(timerId)) {
      setTimer();
    }
  };

  return { start, reset };
};

export default useTimer;
